import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function youAlsoMightLikeBlock() {
	const blocks = document.querySelectorAll('.you-also-might-like-block');
	if (!blocks.length) return;

	blocks.forEach((block) => {
		const el = block.querySelector('[data-js="you-also-might-like-swiper"]');
		if (!el || el.swiper) return;

		const prevEl = block.querySelector('[data-js="you-also-might-like-prev"]');
		const nextEl = block.querySelector('[data-js="you-also-might-like-next"]');

		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 'auto',
			spaceBetween: 24,
			loop: false,
			watchOverflow: true,
			speed: 550,
			autoHeight: false,
			breakpoints: {
				1024: {
					slidesPerView: 3,
					spaceBetween: 32,
				},
			},
			navigation: {
				prevEl,
				nextEl,
			},
		});
	});
}
